
export default {
  name: "TPLinkArrow",
   props: {
    color: {
      type: String,
      default: '#488FFA',
    },
   }
};
